import Head from 'next/head';
import Image from 'next/image';
import ImageZoomModal from '../../atoms/ImageZoomModal';

const DetailPromoHeroSection = ({
  bannerLink,
  imageUrl,
  altImage,
}: {
  bannerLink?: string;
  imageUrl: string;
  altImage: string;
}) => {
  return (
    <section className="mb-4 lg:mt-5 lg:mb-8">
      <Head>
        <link rel="preload" as="image" href={imageUrl} />
      </Head>
      <ImageZoomModal
        classname="z-[200] [&_.zoom-modal-hide]:hidden [&_.zoom-modal-content]:h-full [&_.zoom-modal-content]:rounded-none"
        isWidthAuto={false}
      >
        <Image
          id="image-promo-dtl"
          src={imageUrl}
          alt={altImage}
          priority={true}
          fetchPriority="high"
          width={820}
          height={455}
          sizes="(min-width: 1240px) 811px, (min-width: 1040px) 645px, 100vw"
          quality={65}
          className="w-full object-cover object-center aspect-video"
        />
      </ImageZoomModal>
    </section>
  );
};

export default DetailPromoHeroSection;
